import { createSlice } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { CurrentDate } from '../../types/state';

const initialState: CurrentDate = {
  data: null,
  fetchingStatusDate: false,
  error: null
};

export const currentDateVPO = createSlice({
  name: NameSpace.Date,
  initialState,
  reducers: {
    fetchCurrentDateRequestVPO: (state) => {
      state.fetchingStatusDate = true;
      state.error = null;
    },
    fetchCurrentDateSuccessVPO: (state, action) => {
      state.fetchingStatusDate = false;
      state.data = action.payload;
    },
    fetchCurrentDateFailureVPO: (state, action) => {
      state.fetchingStatusDate = false;
      state.error = action.payload;
    },
  },
});

export const { fetchCurrentDateRequestVPO, fetchCurrentDateSuccessVPO, fetchCurrentDateFailureVPO } = currentDateVPO.actions;
